module.exports = __webpack_public_path__ + "img/medica@2x.027e8215.png";